var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          on: { hide: _vm.hideCourseInfo },
          model: {
            value: _vm.show_course_info,
            callback: function($$v) {
              _vm.show_course_info = $$v
            },
            expression: "show_course_info"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: { click: _vm.hideCourseInfo }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.presential.title) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 q-pa-md" },
                  [
                    _c("div", { staticClass: "col-12 q-my-sm" }, [
                      _c("p", { staticClass: "q-my-xs text-weight-bold" }, [
                        _vm._v(_vm._s(_vm.presential.title))
                      ]),
                      _c("p", { staticClass: "q-my-xs" }, [
                        _vm._v(_vm._s(_vm.presential.description))
                      ]),
                      _c("p", { staticClass: "q-my-xs" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("timezone") +
                              ": " +
                              _vm.getHumanTimezone(_vm.presential.timezone)
                          )
                        )
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-12 q-my-sm" },
                      [
                        _c("p", { staticClass: "q-my-xs text-weight-bold" }, [
                          _vm._v(_vm._s(_vm.$t("instructors")))
                        ]),
                        _vm._l(_vm.presential.instructors_list, function(
                          instructor,
                          index
                        ) {
                          return _c("div", { key: index }, [
                            _c("p", { staticClass: "q-my-xs" }, [
                              _vm._v(
                                _vm._s(instructor.name) +
                                  " - " +
                                  _vm._s(instructor.email)
                              )
                            ])
                          ])
                        })
                      ],
                      2
                    ),
                    _c("div", { staticClass: "col-12 q-my-sm" }, [
                      _c("p", { staticClass: "q-my-xs text-weight-bold" }, [
                        _vm._v(_vm._s(_vm.$t("address")))
                      ]),
                      _c("div", [
                        _c("span", { staticClass: "text-body2" }, [
                          _vm._v(
                            _vm._s(_vm.presential.address.address) +
                              ", " +
                              _vm._s(_vm.presential.address.number) +
                              " - " +
                              _vm._s(_vm.presential.address.neighborhood)
                          )
                        ])
                      ]),
                      _c("div", [
                        _c("span", { staticClass: "text-body2" }, [
                          _vm._v(
                            _vm._s(_vm.presential.address.city) +
                              " - " +
                              _vm._s(_vm.presential.address.state) +
                              "/" +
                              _vm._s(_vm.presential.address.state_initials)
                          )
                        ])
                      ])
                    ]),
                    _vm.presential && _vm.presential.event_dates.length
                      ? _c(
                          "q-card",
                          { staticClass: "bg-grey-1 q-pa-xs q-my-lg" },
                          [
                            _c(
                              "q-card-main",
                              { staticClass: "relative-position" },
                              [
                                _c("q-table", {
                                  staticClass: "shadow-0",
                                  attrs: {
                                    title: _vm.$t("training_events"),
                                    data: _vm.presential.event_dates,
                                    columns: _vm.columns,
                                    "row-key": "id",
                                    dense: "",
                                    "no-data-label": _vm.$t(
                                      "no_data_avaliable"
                                    ),
                                    "no-results-label": _vm.$t(
                                      "no_results_found"
                                    )
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function(props) {
                                          return _c(
                                            "q-tr",
                                            { attrs: { props: props } },
                                            _vm._l(props.cols, function(col) {
                                              return _c(
                                                "q-th",
                                                {
                                                  key: col.name,
                                                  attrs: { props: props }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.$t(col.label)
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        }
                                      },
                                      {
                                        key: "body",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "q-tr",
                                              { attrs: { props: props } },
                                              [
                                                _c(
                                                  "q-td",
                                                  {
                                                    key: "event_date_type",
                                                    attrs: { props: props }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.getEventType(
                                                            props.row
                                                              .event_date_type
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "q-td",
                                                  {
                                                    key: "method",
                                                    attrs: { props: props }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.getEventMethod(
                                                            props.row
                                                              .event_date_type
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "q-td",
                                                  {
                                                    key: "hr_start",
                                                    attrs: { props: props }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.fDateTime(
                                                            props.row.hr_start
                                                          )
                                                        ) +
                                                        "H\n                                        "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "q-td",
                                                  {
                                                    key: "hr_end",
                                                    attrs: { props: props }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.fDateTime(
                                                            props.row.hr_end
                                                          )
                                                        ) +
                                                        "H\n                                        "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1331562078
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("q-card-separator"),
                    !_vm.presential.user_subscribed
                      ? _c("div", { staticClass: "text-center q-mt-sm" }, [
                          _c("span", { staticClass: "text-body2 " }, [
                            _vm._v(_vm._s(_vm.$t("subscription_warning")))
                          ])
                        ])
                      : _vm._e(),
                    _vm.presential.user_subscribed
                      ? _c("div", { staticClass: "text-center q-mt-sm" }, [
                          _c(
                            "span",
                            { staticClass: "text-body2 text-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("you_are_subscribed_warning"))
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c(
                "q-toolbar",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "q-card-actions",
                    [
                      _c("q-btn", {
                        attrs: { label: _vm.$t("close"), color: "tertiary" },
                        on: { click: _vm.hideCourseInfo }
                      }),
                      _c("q-btn", {
                        attrs: {
                          color: _vm.presential.user_subscribed
                            ? "negative"
                            : "positive",
                          label: _vm.presential.user_subscribed
                            ? _vm.$t("unsubscribe")
                            : _vm.$t("subscribe")
                        },
                        on: {
                          click: function($event) {
                            _vm.confirm_subscribe_presential = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          attrs: { "prevent-close": "" },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("close") },
                    on: {
                      click: function($event) {
                        return _vm.hideCourseInfo()
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: {
                      color: _vm.presential.user_subscribed
                        ? "negative"
                        : "positive",
                      label: _vm.presential.user_subscribed
                        ? _vm.$t("unsubscribe")
                        : _vm.$t("subscribe")
                    },
                    on: { click: _vm.toggleSubscription }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_subscribe_presential,
            callback: function($$v) {
              _vm.confirm_subscribe_presential = $$v
            },
            expression: "confirm_subscribe_presential"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(
              _vm._s(
                _vm.presential.user_subscribed
                  ? _vm.$t("unsubscribe")
                  : _vm.$t("subscribe")
              )
            )
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.presential.user_subscribed
                    ? _vm.$t("unsubscribe_confirmation")
                    : _vm.$t("subscribe_confirmation")
                ) +
                "\n        "
            )
          ]),
          !_vm.presential.user_subscribed
            ? _c(
                "span",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c(
                    "q-field",
                    [
                      _c("q-checkbox", {
                        attrs: {
                          label: _vm.$t("receive_emails_about_this_training")
                        },
                        model: {
                          value: _vm.check_emails_presential,
                          callback: function($$v) {
                            _vm.check_emails_presential = $$v
                          },
                          expression: "check_emails_presential"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }